import { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Play } from 'lucide-react';
import { getAnalyzerHandoffWithUrl } from '../../config/api';
import { validateUrl } from '../../utils/urlValidation';

const ENGINE_ICONS = [
  { name: 'Google', color: '#4285F4', svg: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18A10.96 10.96 0 0 0 1 12c0 1.77.42 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05"/><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/></svg>
  )},
  { name: 'Bing', color: '#00897B', svg: (
    <svg viewBox="0 0 24 24" width="18" height="18"><path d="M5 3v16.5l4.67 2.5 7.83-4.5v-4.5L10.5 10V3.5L5 3z" fill="#00897B"/><path d="M10.5 10l7 3-7 4.5V10z" fill="#00BFA5" opacity="0.7"/></svg>
  )},
  { name: 'Yahoo', color: '#6001D2', svg: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="#6001D2"><path d="M12.5 14.2L7 4h3.3l3.2 6.6L16.7 4H20l-5.5 10.2V20h-2V14.2z"/></svg>
  )},
  { name: 'DuckDuckGo', color: '#DE5833', svg: (
    <svg viewBox="0 0 24 24" width="18" height="18"><circle cx="12" cy="12" r="10" fill="#DE5833"/><circle cx="10" cy="10" r="2.5" fill="#fff"/><circle cx="10" cy="10" r="1.2" fill="#2D4F2D"/><ellipse cx="14.5" cy="14" rx="3" ry="2" fill="#F5D03B"/></svg>
  )},
  { name: 'ChatGPT', color: '#10A37F', svg: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="#10A37F"><path d="M22.28 11.25a5.23 5.23 0 0 0-.45-4.31 5.3 5.3 0 0 0-5.71-2.53A5.27 5.27 0 0 0 12.17 2a5.3 5.3 0 0 0-5.05 3.65 5.26 5.26 0 0 0-3.52 2.55 5.3 5.3 0 0 0 .65 6.23 5.23 5.23 0 0 0 .45 4.31 5.3 5.3 0 0 0 5.71 2.53A5.27 5.27 0 0 0 14.36 23a5.3 5.3 0 0 0 5.05-3.65 5.26 5.26 0 0 0 3.52-2.55 5.3 5.3 0 0 0-.65-5.55zM14.36 21.54a3.96 3.96 0 0 1-2.54-.92l.13-.07 4.22-2.44a.68.68 0 0 0 .35-.6v-5.95l1.78 1.03a.06.06 0 0 1 .04.05v4.93a3.97 3.97 0 0 1-3.98 3.97zM4.54 17.6a3.94 3.94 0 0 1-.47-2.66l.12.08 4.22 2.44a.69.69 0 0 0 .69 0l5.15-2.98v2.06a.07.07 0 0 1-.03.06l-4.27 2.46A3.97 3.97 0 0 1 4.54 17.6zM3.28 8.28A3.95 3.95 0 0 1 5.34 6.5v5.02a.68.68 0 0 0 .34.6l5.15 2.97-1.78 1.03a.07.07 0 0 1-.07 0L4.71 13.67a3.97 3.97 0 0 1-1.43-5.39zm15.65 3.65-5.15-2.98 1.78-1.03a.07.07 0 0 1 .07 0l4.27 2.47a3.97 3.97 0 0 1-.61 7.17v-5.03a.69.69 0 0 0-.36-.6zm1.77-2.67-.12-.08-4.22-2.44a.69.69 0 0 0-.69 0L10.52 9.7V7.65a.07.07 0 0 1 .03-.06l4.27-2.46a3.97 3.97 0 0 1 5.88 4.13zm-11.14 3.68-1.79-1.03a.06.06 0 0 1-.03-.05V6.93a3.97 3.97 0 0 1 6.52-3.05l-.13.07-4.22 2.44a.68.68 0 0 0-.35.6v5.95zm.97-2.1L12.84 9.5l2.3 1.33v2.66l-2.3 1.33-2.31-1.33v-2.66z"/></svg>
  )},
  { name: 'Perplexity', color: '#1FB8CD', svg: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="#1FB8CD"><path d="M12 2L4 7v10l8 5 8-5V7l-8-5zm0 2.36L17.5 8 12 11.64 6.5 8 12 4.36zM5.5 9.16L11 12.5v6.84l-5.5-3.43V9.16zm7 10.18v-6.84l5.5-3.34v6.75l-5.5 3.43z"/></svg>
  )},
  { name: 'Gemini', color: '#4285F4', svg: (
    <svg viewBox="0 0 24 24" width="18" height="18"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10c1.85 0 3.58-.51 5.06-1.39l-1.64-2.84A6.96 6.96 0 0 1 12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7c1.5 0 2.88.47 4.02 1.28l1.64-2.84A9.95 9.95 0 0 0 12 2z" fill="#4285F4"/><path d="M20.59 8.27l-1.64 2.84A6.93 6.93 0 0 1 19 12c0 1.5-.47 2.88-1.28 4.02l1.64 2.84A9.95 9.95 0 0 0 22 12c0-1.39-.28-2.72-.79-3.93l-.62-1.8z" fill="#34A853"/><circle cx="12" cy="12" r="3" fill="#EA4335"/></svg>
  )},
  { name: 'Claude', color: '#D97757', svg: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="#D97757"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm3.5 14.5h-7v-1.17l4.15-4.15a2.5 2.5 0 1 0-3.53-3.54l-.12.13-1.06-1.06.12-.13a4 4 0 1 1 5.66 5.65L10.3 15.5h5.2v1z"/></svg>
  )},
  { name: 'Grok', color: '#000', svg: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="#000"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
  )},
];

const HeroSection = () => {
  const [url, setUrl] = useState('');
  const [urlError, setUrlError] = useState('');

  const handleAnalyze = (e) => {
    e.preventDefault();
    setUrlError('');
    const trimmed = url.trim();
    if (!trimmed) {
      setUrlError('Please enter a URL');
      return;
    }
    const v = validateUrl(trimmed);
    if (!v.valid) {
      setUrlError(v.error || 'Please enter a valid URL');
      return;
    }
    window.location.href = getAnalyzerHandoffWithUrl(v.cleanUrl);
  };

  return (
    <section className="relative overflow-hidden py-20 md:py-28 lg:py-32">
      <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
        <motion.div
          className="absolute -top-32 -left-32 w-96 h-96 rounded-full bg-cv-sky/30"
          style={{ filter: 'blur(80px)' }}
          animate={{ x: [0, 30, 0], y: [0, -20, 0] }}
          transition={{ duration: 8, repeat: Infinity, ease: 'easeInOut' }}
        />
        <motion.div
          className="absolute -bottom-24 -right-24 w-80 h-80 rounded-full bg-cv-teal/20"
          style={{ filter: 'blur(80px)' }}
          animate={{ x: [0, -25, 0], y: [0, 25, 0] }}
          transition={{ duration: 10, repeat: Infinity, ease: 'easeInOut' }}
        />
        <motion.div
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-cv-gold/10"
          style={{ filter: 'blur(120px)' }}
          animate={{ scale: [1, 1.1, 1] }}
          transition={{ duration: 12, repeat: Infinity, ease: 'easeInOut' }}
        />
      </div>

      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 text-center">
        {/* Badge */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="inline-flex items-center gap-2 px-4 py-1.5 mb-8 bg-white/80 backdrop-blur-sm border border-cv-sky/30 rounded-full text-sm font-medium text-cv-navy shadow-sm"
        >
          <span className="w-2 h-2 bg-cv-teal rounded-full animate-pulse" />
          Domain-Scale Technical SEO &amp; AI Visibility Platform
        </motion.div>

        {/* Headline */}
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-tight mb-6"
        >
          <span className="text-cv-navy">
            Make Your Website Visible
          </span>
          <br />
          <span className="text-cv-navy">
            to Search <span className="text-cv-navy">&amp;</span> AI Engines
          </span>
        </motion.h1>

        {/* Subheadline */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="text-lg sm:text-xl text-cv-navy/70 max-w-2xl mx-auto mb-10 leading-relaxed"
        >
          Start with a page-level check or run <span className="font-semibold text-cv-navy">Domain Analysis</span> to map
          sitemap-driven page groups, score your domain at scale, and uncover issues blocking indexing, ranking, and AI discovery — so assistants like
          <span className="font-semibold text-cv-navy"> ChatGPT</span>,
          <span className="font-semibold text-cv-navy"> Perplexity</span>, and
          <span className="font-semibold text-cv-navy"> Google Gemini</span> can actually see your site.
        </motion.p>

        {/* URL Input + CTA */}
        <motion.form
          onSubmit={handleAnalyze}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.35 }}
          className="max-w-2xl mx-auto mb-6"
        >
          <div className="flex flex-col sm:flex-row gap-3">
            <input
              type="url"
              value={url}
              onChange={(e) => { setUrl(e.target.value); if (urlError) setUrlError(''); }}
              placeholder="https://example.com"
              className={`flex-1 px-5 py-4 bg-white border-2 rounded-xl text-cv-navy/90 placeholder:text-cv-navy/40 focus:outline-none focus:ring-2 focus:ring-cv-navy focus:border-transparent shadow-sm transition-all text-base ${urlError ? 'border-cv-orange/40' : 'border-cv-navy/15'}`}
              aria-label="Website URL to analyze"
              aria-invalid={!!urlError}
              aria-describedby={urlError ? 'hero-url-error' : undefined}
            />
            <button
              type="submit"
              className="px-8 py-4 bg-cv-navy text-white font-bold rounded-xl hover:shadow-xl shadow-lg shadow-cv-navy/25 transition-all flex items-center justify-center gap-2 text-base whitespace-nowrap"
            >
              Analyze My Website <ArrowRight className="w-5 h-5" />
            </button>
          </div>
          {urlError && (
            <p id="hero-url-error" className="mt-2 text-left text-sm text-cv-orange" role="alert">
              {urlError}
            </p>
          )}
        </motion.form>

        {/* Secondary CTA */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6"
        >
          <a
            href="/analyzer?mode=domain"
            className="inline-flex items-center gap-2 px-6 py-3 bg-white border-2 border-cv-sky/50 text-cv-navy font-semibold rounded-xl hover:border-cv-navy hover:bg-cv-sky/10 transition-all text-sm"
          >
            <ArrowRight className="w-4 h-4" /> Try Domain Analysis
          </a>
          <a
            href="/sample-report.html"
            target="_blank"
            rel="noopener"
            className="inline-flex items-center gap-2 px-6 py-3 border-2 border-cv-gold/50 text-cv-navy font-semibold rounded-xl hover:border-cv-gold/50 hover:bg-cv-gold/15 transition-all text-sm"
          >
            <Play className="w-4 h-4" /> View Sample Report
          </a>
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }}
            className="inline-flex items-center gap-2 px-6 py-3 border-2 border-cv-navy/25 text-cv-navy/80 font-semibold rounded-xl hover:border-cv-navy hover:text-cv-navy transition-all text-sm"
          >
            <Play className="w-4 h-4" /> Book Demo
          </a>
          <a
            href="/sample-dashboard.html"
            target="_blank"
            rel="noopener"
            className="inline-flex items-center gap-2 px-6 py-3 border-2 border-cv-navy/25 text-cv-navy/80 font-semibold rounded-xl hover:border-cv-navy hover:text-cv-navy transition-all text-sm"
          >
            <Play className="w-4 h-4" /> Sample Dashboard
          </a>
        </motion.div>

        {/* Microtext */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.6 }}
          className="text-sm text-cv-navy/60 flex flex-wrap items-center justify-center gap-x-4 gap-y-1"
        >
          <span>✓ Free analysis</span>
          <span>✓ No signup required</span>
          <span>✓ Domain Analysis for premium users</span>
        </motion.p>

        {/* Search & AI Engine Icons */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.75 }}
          className="mt-8"
        >
          <p className="text-xs text-cv-navy/40 uppercase tracking-wider font-medium mb-3">
            Optimize for Search &amp; AI Engines
          </p>
          <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-4">
            {ENGINE_ICONS.map((engine) => (
              <div
                key={engine.name}
                className="flex items-center gap-1.5 px-3 py-1.5 bg-white/70 backdrop-blur-sm border border-cv-navy/60 rounded-full shadow-sm hover:shadow-md hover:border-cv-navy/25 transition-all group"
                title={engine.name}
              >
                <span className="opacity-75 group-hover:opacity-100 transition-opacity flex-shrink-0">
                  {engine.svg}
                </span>
                <span className="text-xs font-medium text-cv-navy/70 group-hover:text-cv-navy transition-colors hidden sm:inline">
                  {engine.name}
                </span>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
